module.exports = Object.keys || require('./shim');




/*****************
 ** WEBPACK FOOTER
 ** ./~/object-keys/index.js
 ** module id = 510
 ** module chunks = 0
 **/